import React, { useMemo } from 'react';
import Img from 'gatsby-image';
import { Box } from 'rebass';
import { Image as RebassImage } from 'rebass';

import { createCleanUrl, getFluidProps, getPlaceholderImageSrc } from './util';
import { parseSpacing } from '../../utils/parseSpacing';

const sharedStyle = {
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
};

export const Image = ({
  blurLoad,
  image,
  isBackgroundImage,
  isHighQuality,
  minSize,
  mobileImage,
  mobileMinSize,
  ImgToRender = Img,
  height,
  width,
  ...otherProps
}) => {
  const fluidProps = useMemo(
    () => getFluidProps(image, minSize, isHighQuality ? 100 : 80),
    [image, isHighQuality, minSize]
  );

  const mobileFluidProps = useMemo(
    () =>
      getFluidProps(
        mobileImage.filename ? mobileImage : image,
        mobileMinSize || minSize,
        isHighQuality ? 100 : 70
      ),
    [image, isHighQuality, minSize, mobileImage, mobileMinSize]
  );

  if (image?.filename?.toLowerCase().endsWith('.svg')) {
    return (
      <RebassImage
        alt={image.alt}
        height={height || '100%'}
        src={image.filename}
        title={image.title}
        sx={{
          maxWidth: parseSpacing(width),
        }}
        loading="lazy"
        {...otherProps}
      />
    );
  }

  const backgroundImage = blurLoad
    ? createCleanUrl(getPlaceholderImageSrc(image))
    : 'none';

  const mobileBackgroundImage = blurLoad
    ? createCleanUrl(
        getPlaceholderImageSrc(mobileImage.filename ? mobileImage : image)
      )
    : 'none';

  return fluidProps && fluidProps.src ? (
    <>
      <Box display={['contents', , , 'none']}>
        <ImgToRender
          alt={mobileImage.alt ?? image.alt}
          title={mobileImage.title ?? image.title}
          fluid={
            isBackgroundImage && blurLoad
              ? [createCleanUrl(mobileFluidProps.src), mobileBackgroundImage]
              : mobileFluidProps
          }
          {...otherProps}
          style={{
            ...sharedStyle,
            ...otherProps.style,
          }}
          loading="lazy"
        />
      </Box>
      <Box display={['none', , , 'contents']}>
        <ImgToRender
          alt={image.alt}
          title={image.title}
          fluid={
            isBackgroundImage && blurLoad
              ? [createCleanUrl(fluidProps.src), backgroundImage]
              : fluidProps
          }
          {...otherProps}
          style={{
            ...sharedStyle,
            ...otherProps.style,
          }}
          loading="lazy"
        />
      </Box>
    </>
  ) : (
    <strong>Select an image</strong>
  );
};

export const ImageComponent = ({
  noBlur,
  image,
  isBackgroundImage,
  isHighQuality,
  minSize,
  mobileImage,
  mobileMinSize,
  height,
  width,
}) => {
  return (
    <Image
      blurLoad={!noBlur}
      image={image}
      isBackgroundImage={isBackgroundImage}
      isHighQuality={isHighQuality}
      minSize={minSize}
      mobileImage={mobileImage}
      mobileMinSize={mobileMinSize}
      height={height}
      width={width}
    />
  );
};

export default ImageComponent;
